/**
 * useLockedReservationCountForOffers — total count of reservations locked by
 * an accepted-version acceptance for a set of offers (source:
 * 'offer_version_locked'). Shared by the single-offer withdraw-acceptance
 * dialog (features/offer-versions) and the offer-list bulk withdraw-acceptance
 * dialog (features/offers) so both preview counts stay derived from the exact
 * same filter criteria. Neutral home (CU-86cbek5j5 extraction) since neither
 * consumer is features/reservations itself — cross-feature import of
 * features/reservations from features/offers or features/offer-versions is
 * forbidden (WEB_ARCHITECTURE.md:36).
 */
import { useQueries } from '@tanstack/react-query';
import { useRouteContext } from '@tanstack/react-router';
import { reservations } from '@ooh/contracts';
import { reservationListRequest, reservationQueryKeys } from '@ooh/screens';

export function useLockedReservationCountForOffers(offerIds: number[], enabled: boolean) {
  const { auth } = useRouteContext({ from: '__root__' });
  const results = useQueries({
    queries: offerIds.map((offerId) => {
      const params = { offerId: [offerId], source: ['offer_version_locked'], limit: 1 };
      return {
        queryKey: reservationQueryKeys.list(params),
        queryFn: () => auth.callWithAuth(reservations.list, reservationListRequest(params)),
        enabled,
      };
    }),
  });
  const total = results.reduce((sum, r) => sum + (r.data?.total ?? 0), 0);
  const isLoading = results.some((r) => r.isLoading);
  return { total, isLoading };
}
